import { render, staticRenderFns } from "./TraxTrainingCompetencyDomainsEditForm.vue?vue&type=template&id=749346f3"
import script from "./TraxTrainingCompetencyDomainsEditForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyDomainsEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports